import type { SchedulingEnrollment } from '@/types/scheduling';
import type { StudentSchedulingDetails } from '../api/getStudentsSchedulingDetails';

export const isEnrollmentSchedulable = (enrollment: SchedulingEnrollment, studentSchedulingDetails: StudentSchedulingDetails): boolean => {
  if (enrollment.blockGuardianScheduling === true) {
    return false;
  }

  const canScheduleInCenter = enrollment.deliveryTypes.includes('IN-CENTER') && studentSchedulingDetails.inCenterCenterSettings?.scheduling_enabled === true;
  const canScheduleOnline = enrollment.deliveryTypes.includes('ONLINE') && studentSchedulingDetails.onlineCenterSettings?.scheduling_enabled === true;
  return canScheduleInCenter || canScheduleOnline;
};

export const canStudentSchedule = (studentSchedulingDetails: StudentSchedulingDetails): boolean => {
  return studentSchedulingDetails.enrollments.some((enrollment) => isEnrollmentSchedulable(enrollment, studentSchedulingDetails));
};

export const getSchedulableDeliveryTypes = (
  enrollment: SchedulingEnrollment,
  studentSchedulingDetails: StudentSchedulingDetails,
): ('IN-CENTER' | 'ONLINE')[] => {
  if (enrollment.blockGuardianScheduling === true) {
    return [];
  }

  const result: ('IN-CENTER' | 'ONLINE')[] = [];
  if (enrollment.deliveryTypes.includes('IN-CENTER') && studentSchedulingDetails.inCenterCenterSettings?.scheduling_enabled === true) {
    result.push('IN-CENTER');
  }
  if (enrollment.deliveryTypes.includes('ONLINE') && studentSchedulingDetails.onlineCenterSettings?.scheduling_enabled === true) {
    result.push('ONLINE');
  }
  return result;
};
